import React from "react";
import type { ImgHTMLAttributes } from "react";
import "./Brand.css";

export const BrandSymbol: React.FC<ImgHTMLAttributes<HTMLImageElement>> = ({ className = "", ...props }) => (
  <img src="/logo_ta.png" alt="TA" width={40} height={40} className={`brand-symbol ${className}`} {...props} />
);

export default BrandSymbol;
